import OwlCarousel from 'react-owl-carousel3';
import React, { useState, useEffect } from 'react';

const Currency = (Props) => {
    const current_currency = localStorage.getItem('current_currency') ? JSON.parse(localStorage.getItem('current_currency')) : { currency: 1, country_code: 'KWD' };
    return ' ' + current_currency.country_code + ' ' + ((parseFloat(current_currency.currency) * Props.data).toFixed(3))

}
export default Currency;